import { AdmService } from 'src/app/shared/services/adm.service';
import { Component, OnInit } from '@angular/core';
import { ConfigService } from 'src/app/shared/services/config.service';
import { forkJoin } from 'rxjs';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { isMobile } from 'src/app/shared/utils/helpers';
import { Router } from '@angular/router'
import { SnackbarService } from 'src/app/shared/services/snackbar.service';
import { UsuariosService } from 'src/app/shared/services/usuarios.service';

@Component({
  selector: 'app-verificar-cuenta',
  templateUrl: './verificar-cuenta.component.html'
})
export class VerificarCuentaComponent implements OnInit {

  public Etiquetas: {
    Boton: string
    CorreoElectronico: string
    MailContacto: string
    SolicitudClaveNueva: string
    Titulo: string
    UserName: string
    YaEstoyVerificado: string
    Ayuda: string
    LeadText1: string
    LeadText2: string
    LeadText3: string
    LeadText4: string
    LogoBayerBlanco: string
    LogoBayerColor: string
  }

  public Tooltips: {
    IrALogin: string
  }

  public Validaciones: {
    EscribirUsuarioRed: string
  }

  form: FormGroup;

  constructor(
    private admService: AdmService,
    private fb: FormBuilder,
    private router: Router,
    private usuariosService: UsuariosService,
    public configService: ConfigService,
    private snackBarService: SnackbarService) { }

  ngOnInit() {

    this.Validaciones = {
      EscribirUsuarioRed: this.configService.validaciones.VerificarCuenta.EscribirUsuarioRed,
    }
    this.Etiquetas = {
      Ayuda: this.configService.etiquetas.VerificarCuenta.Ayuda,
      Boton: this.configService.etiquetas.VerificarCuenta.Boton,
      CorreoElectronico: this.configService.etiquetas.VerificarCuenta.CorreoElectronico,
      LeadText1: this.configService.etiquetas.VerificarCuenta.LeadText1,
      LeadText2: this.configService.etiquetas.VerificarCuenta.LeadText2,
      LeadText3: this.configService.etiquetas.VerificarCuenta.LeadText3,
      LeadText4: this.configService.etiquetas.VerificarCuenta.LeadText4,
      LogoBayerBlanco: this.configService.etiquetas.LogoBayerBlanco,
      LogoBayerColor: this.configService.etiquetas.LogoBayerColor,
      MailContacto: this.configService.etiquetas.MailContacto,
      SolicitudClaveNueva: this.configService.etiquetas.VerificarCuenta.SolicitudClaveNueva,
      Titulo: this.configService.etiquetas.Login.Titulo,
      UserName: this.configService.etiquetas.VerificarCuenta.UserName,
      YaEstoyVerificado: this.configService.etiquetas.VerificarCuenta.YaEstoyVerificado
    }

    this.Tooltips = {
      IrALogin: this.configService.tooltips.VerificarCuenta.IrALogin
    }

    this.form = this.fb.group({
      UserName: ['', [Validators.required]]
    });

  }

  get usuarioRed() {
    return this.form.get('UserName');
  }



  login() {
    this.router.navigateByUrl(this.configService.etiquetas.Login.Path)
  }

  clearUsername() {
    this.form.controls['UserName'].setValue('');
    this.form.controls['UserName'].markAsUntouched();
  }
  get userName() {
    return this.form.get('UserName');
  }


  aceptar() {



    this.usuariosService.cNuevaClaveVerificacion(this.form.value).subscribe(() => {

      this.snackBarService.openSnackbar(this.configService.mensajes.TituloCorreoEnviado, this.configService.mensajes.LoginUsuario.VerificarCuenta, 1, 1);

      this.router.navigateByUrl('/', { skipLocationChange: true })
        .then(() => {
          localStorage.removeItem('TokenBearer');
          localStorage.removeItem('PortalCS');
          // location.reload();
          this.router.navigate(['/login'])
        }

        );
    });



  }

  isMobile() {
    return isMobile();
  }


}
